import React from 'react';
import { Link } from 'react-router-dom';
import Logo  from '../images/logo.png'

export const Dashboard = () => {

	return (
		
		<div className="flex flex-column">
			<h1>Welcome to CRG's client authoring system!</h1>
			<div>
				<Link to="/anhi-programs">
					Add, edit, remove ANHI programs
				</Link>
			</div>
			<div>
				<Link to="/users">
					Add or Remove Users
				</Link>
			</div>
			<div>
				<Link to="/audit">
					View a detailed Audit Log
				</Link>
			</div>
		</div>
	);
}
